import styled, { css } from "styled-components";
import { Link as RLink } from "react-router-dom";

const ButtonTypes = css`
  border-radius: 5px;
  cursor: pointer;
  border: none;
  font-size: ${(props) => props.theme.font.small};
  height: ${(props) => props?.height || props.theme.sizes.buttonHeight};
  line-height: 21.94px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.3rem 1rem;
  margin: 0.5rem;
  font-weight: 300;
`;

const LinkType = css`
  // primary Link
  ${(props) =>
    props.type === "primary" ? `color: ${props.theme.colors.primary};` : ""}
  ${(props) =>
    props.type === "primary"
      ? `&:hover {color: ${props.theme.colors.lightPrimary}}`
      : ""}
  ${(props) =>
    props.type === "primary"
      ? `&:active {color: ${props.theme.colors.extralightPrimary}}`
      : ""}

 //secondary Link

  ${(props) =>
    props.type === "secondary" ? `color: ${props.theme.colors.secondary};` : ""}
  ${(props) =>
    props.type === "secondary"
      ? `&:hover {color: ${props.theme.colors.lightSecondary}}`
      : ""}
  ${(props) =>
    props.type === "secondary"
      ? `&:active {color: ${props.theme.colors.extraLightSecondary}}`
      : ""}
`;

export const Button = styled.button`
  ${ButtonTypes};
  color: ${({ theme }) => theme.colors.white};
  ${(props) =>
    props.type === "primary" && `background: ${props.theme.colors.primary};`}
  ${(props) =>
    props.type === "secondary" &&
    `background: ${props.theme.colors.secondary};`}
  ${(props) =>
    props.type === "primary" &&
    `&:hover {background: ${props.theme.colors.lightPrimary}}`}
  ${(props) =>
    props.type === "secondary" &&
    `&:hover {background: ${props.theme.colors.lightSecondary}}`}
  ${(props) =>
    props.type === "primary" &&
    `&:active {background: ${props.theme.colors.extralightPrimary}}`}
  ${(props) =>
    props.type === "secondary" &&
    `&:active {background: ${props.theme.colors.extraLightSecondary}}`}

  ${(props) =>
    props.type === "outline" &&
    `background: ${props.theme.colors.transparent};
      color: ${props.theme.colors.primary};
      border: 1px solid ${props.theme.colors.primary};
      &:hover {
        color: ${props.theme.colors.white};
        border: 1px solid ${props.theme.colors.white};
        
      }
      &:active {
        background: ${props.theme.colors.transparentPrimary};
      color: ${props.theme.colors.primary};
      border: 1px solid ${props.theme.colors.transparentPrimary};
    }
      
      `}
`;

export const Link = styled(RLink)`
  ${LinkType};
  text-decoration: none;
  display: flex;
  margin: 0 0.5rem;
  cursor: pointer;
  ${(props) => props.color && `color: ${props.color};`}
  @media (max-width: 768px) {
    padding: 0.8rem 0.8rem;
  }
`;
export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: ${({ fit }) => (fit ? fit : "cover")};
`;
export const Icon = styled.img`
  width: 22px;
  object-fit: contain;
`;
